// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.solutions.practicepay.PracticePaySettingsResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticePaySettingsResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	hasStore!: boolean;

	@GandalfProperty({ designType: Boolean })
	payOnlineEnabled!: boolean;

	@GandalfProperty({ designType: String })
	payOnlineUrlPath!: string | null;

	@GandalfProperty({ designType: Number })
	practiceLocationId!: number;

	@GandalfProperty({ designType: Number })
	practicePaySettingsId!: number;

	@GandalfProperty({ designType: Boolean })
	statementPayOnlineEnabled!: boolean;

}
